/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import store from '@/store/';
import {getStore} from '@/util/store'
import router from '@/router/index';
import {serialize} from '@/util/util';
import {getToken} from '@/util/auth';
import website from '@/config/website';
import {Base64} from 'js-base64';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import {setStore} from "../util/store";
import {Toast} from "vant";
let ignoreUrl=['/api/blade-auth/oauth/captcha','/api/blade-auth/oauth/token','/api/blade-system/tenant/info']
//默认超时时间
axios.defaults.timeout = 50000;

//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};

//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

// NProgress 配置
NProgress.configure({
  showSpinner: false
});

//http request拦截
let isRefresh = false;
axios.interceptors.request.use(config => {
  //开启 progress bar
  NProgress.start();
  const meta = (config.meta || {});
  const isToken = meta.isToken === false;
  config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
  //让每个请求携带token
  //发起请求前检验是否要刷新token
  let date = new Date().getTime();
  if (config.url.includes("oauth/token") && config.params && config.params.grant_type!='refresh_token'){
    setStore({name: 'freshTime', content: date});
  }


  let lastOperationTime = getStore({name: 'lastOperationTime'});
  if (!lastOperationTime){
    lastOperationTime = date;
  }
  // if(date - lastOperationTime >= 30*60 * 1000 && !ignoreUrl.includes(config.url)){
  //   Toast.fail('超过三十分钟未操作，自动退出')
  //   setTimeout(() => {
  //     store.dispatch('FedLogOut').then(() => {
  //       router.push({path: '/login'})
  //     })
  //   }, 200);
  //
  // } else {
  //   setStore({name:'lastOperationTime', content: date})
  // }

  let freshTime=getStore({name:'freshTime'});

  if (getStore({name: 'refreshToken'}) && freshTime != null && freshTime != undefined
    && (date - freshTime) >= 3000 * 1000 && !isRefresh) {
    console.log("刷新了token");
    isRefresh = true;
    store.dispatch('refreshToken').then(() => {
      console.log("刷新成功:", date);
      isRefresh = false;
      setStore({name: 'freshTime', content: date});
    });
  }


  // 请求接口的鉴权 csy
  if (getToken() && !isToken) {
    config.headers[website.tokenHeader] = 'bearer ' + getToken()
  }

  //headers中配置text请求
  if (config.text === true) {
    config.headers["Content-Type"] = "text/plain";
  }

  // headers中配置项目id csy
  let currUserTenant = getStore({name: 'currUserTenant'})
  if(currUserTenant) {
    // console.log(333,currUserTenant.tenantId)
    config.headers["Oper-Tenant-Id"] = currUserTenant.tenantId
  }

  //headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }

  // 请求发出时，添加到cancelTokenArr中
  config.cancelToken = new axios.CancelToken(e => {
    store.commit('addCancelToken', {
        cancel: e,
        url: location.host + config.url
    })
  })

  return config
}, error => {
  return Promise.reject(error)
});

//http response 拦截
axios.interceptors.response.use(res => {
  //关闭 progress bar
  NProgress.done();
  //获取状态码
  const status = res.data.code || res.status;
  const statusWhiteList = website.statusWhiteList || [];
  const message = res.data.msg || res.data.error_description || '未知错误';
  //如果在白名单里则自行catch逻辑处理
  if (statusWhiteList.includes(status)) return Promise.reject(res);
  //如果是401则跳转到登录页面
  if (status === 401) {
    Toast.fail(message);
    store.dispatch('FedLogOut').then(() => {
      window.location.href = '/#/login?redirect=' + location.hostname;
      //router.push({path: '/login', query: {redirect: location.hostname}})
    });
  }
  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    // this.$toast(message)
    return Promise.reject(new Error(message))
  }
  return res;
}, error => {
  NProgress.done();
  // 这里判断异常情况，如果axios.isCancel 为 true时，说明请求被取消
  if (axios.isCancel(error)) {
    // 请求取消
    console.warn(error)
    console.table([error.message.split('---')[0]], 'cancel')
  } else {
    return Promise.reject(new Error(error));
  }
});

export default axios;



// WEBPACK FOOTER //
// ./src/router/axios.js